import { actionButtonStyles } from './styles/actionButton';
import { commandBarButtonStyles, commandBarStyles } from './styles/commandBar';
import { dropdownStyles } from './styles/dropdownStyles';
import { cardStyles } from './styles/card';
import { checkboxStyles } from './styles/check';
import { detailsListStyles, detailsListRowStyles, groupHeaderStyles, groupedListStyles, } from './styles/detailsList';
import { modalStyles, overlayStyles, panelStyles } from './styles/overlayItems';
import { textfieldStyles } from './styles/textfieldStyles';
import { linkStyles } from './styles/link';
import { choiceGroupStyles } from './styles/choiceGroup';
/** Fluent v8 "scoped settings" style generator for the advanced customizer. */
export const makeScopedSettings = (theme, isDarkTheme) => ({
    ActionButton: {
        styles: actionButtonStyles(theme),
    },
    // TODO: Add in the rest of these as we find style bugs
    // Breadcrumb: {
    //   styles: BreadcrumbStyles,
    // },
    Card: {
        styles: cardStyles(theme),
    },
    // CalloutContent: {
    //   styles: CalloutContentStyles,
    // },
    // ColorPicker: {
    //   styles: ColorPickerStyles,
    // },
    // ColorRectangle: {
    //   styles: ColorRectangleStyles,
    // },
    // ColorSlider: {
    //   styles: ColorSliderStyles,
    // },
    CommandBar: {
        styles: commandBarStyles(theme),
    },
    CommandBarButton: {
        styles: commandBarButtonStyles(theme),
    },
    // CompoundButton: {
    //   styles: CompoundButtonStyles(theme),
    // },
    // Check: {
    //   styles: CheckStyles,
    // },
    Checkbox: {
        styles: checkboxStyles(theme),
    },
    ChoiceGroupOption: {
        styles: choiceGroupStyles(theme),
    },
    // ColorPickerGridCell: {
    //   styles: ColorPickerGridCellStyles,
    // },
    // ComboBox: {
    //   styles: ComboBoxStyles(theme),
    // },
    // ContextualMenu: {
    //   styles: ContextualMenuStyles,
    // },
    // DefaultButton: {
    //   styles: DefaultButtonStyles(theme),
    // },
    DetailsList: {
        styles: detailsListStyles(theme),
    },
    DetailsRow: {
        styles: detailsListRowStyles(theme),
    },
    // DialogContent: {
    //   styles: DialogContentStyles,
    // },
    // DialogFooter: {
    //   styles: DialogFooterStyles,
    // },
    // DocumentCard: {
    //   styles: DocumentCardStyles,
    // },
    Dropdown: {
        styles: dropdownStyles(theme),
    },
    // ExpandingCard: {
    //   styles: ExpandingCardStyles,
    // },
    GroupHeader: {
        styles: groupHeaderStyles(theme),
    },
    GroupedList: {
        styles: groupedListStyles(theme),
    },
    // IconButton: {
    //   styles: IconButtonStyles(theme),
    // },
    // Label: {
    //   styles: LabelStyles,
    // },
    Link: {
        styles: linkStyles(theme, isDarkTheme),
    },
    // MessageBar: {
    //   styles: messageBarStyles(theme, isDarkTheme),
    // },
    Modal: {
        styles: modalStyles(theme),
    },
    Overlay: {
        styles: overlayStyles(theme),
    },
    // Nav: {
    //   styles: NavStyles,
    // },
    // Pivot: {
    //   styles: PivotStyles,
    // },
    // PlainCard: {
    //   styles: PlainCardStyles,
    // },
    Panel: {
        styles: panelStyles(theme),
    },
    // PrimaryButton: {
    //   styles: primaryButtonStyles,
    // },
    // ProgressIndicator: {
    //   styles: ProgressIndicatorStyles,
    // },
    // Rating: {
    //   styles: RatingStyles,
    // },
    // Slider: {
    //   styles: SliderStyles,
    // },
    // SearchBox: {
    //   styles: SearchBoxStyles,
    // },
    // SpinButton: {
    //   styles: SpinButtonStyles(theme),
    // },
    // TagPicker: {
    //   styles: TagPickerStyles,
    // },
    // TagItem: {
    //   styles: TagItemStyles,
    // },
    // SuggestionItem: {
    //   styles: SuggestionItemStyles,
    // },
    // Suggestions: {
    //   styles: SuggestionsStyles,
    // },
    // TeachingBubble: {
    //   styles: TeachingBubbleStyles,
    // },
    TextField: {
        styles: textfieldStyles(theme),
    },
    // Toggle: {
    //   styles: ToggleStyles,
    // },
});
